<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/dingdwxlist',title:'订单管理'},{title:'创建订单'}]"/>
        <!---------------------------------------------------项目信息-------------------------------------------------------------------->
        <div class="h-piece" style="margin:20px">
            <div class="h-pieceIn2 n-xiao" v-if="order.orderProjectCode">
                <div class="h-pieceTitle2 " style="margin-left:10px">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine">
                        <el-form :model="order" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="项目名称" class="h-elformWrap-2">
                                <el-input v-model="order.orderProjectName" readonly></el-input>
                            </el-form-item>
                            <el-form-item v-if="contractflag" label="项目合同编号" class="h-elformWrap-2">
                                <el-input v-model="order.orderSubContract" readonly></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------项目信息-------------------------------------------------------------------->
            <!-- 合同信息 -->
            <div class="h-pieceIn2" v-if="showRent">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>合同信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form label-position="right" :inline="true" ref="form0" :model="order"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="关联合同" class="h-elformWrap-2">
                                <el-input v-model="contract.contractName" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="合同开始时间" class="h-elformWrap-2">
                                <el-input v-model="contract.contractStarttime" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="合同结束时间" class="h-elformWrap-2">
                                <el-input v-model="contract.contractEndtime" readonly></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>订单信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form label-position="right" :inline="true" ref="form0" :model="order"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="订单类型" class="h-elformWrap-2">
                                <el-input v-model="xsqyStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建人" class="h-elformWrap-2">
                                <el-input v-model="this.order.cuname" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建时间" class="h-elformWrap-2">
                                <el-input v-model="this.order.cdate" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="订购原因" prop="businessReason" class="h-elformWrap-2" v-if="showIsFree"
                                          :rules="[
							  { required: true, message: '请选择订购原因', trigger: 'change'},
							]">
                                <brselect clearable category="business_reason" :v="order.businessReason"
                                          v-model="order.businessReason"></brselect>
                            </el-form-item>
                            <el-form-item prop="note" label="备注" :rules="[
								  {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
								]" class="h-elformWrap-2">
                                <el-input v-model="order.note" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->
            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>客户信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="order" ref="form1" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item prop="soldToName" label="售达方名称"
                                          :rules="[
								  { required: true, message: '请输入售达方名称', trigger: 'input'},
								]" class="h-elformWrap-2">
                                <el-input v-model="order.soldToName" placeholder="请输入" readonly>
                                    <i
                                            v-if="selectDailishang"
                                            class="el-icon-search el-input__icon"
                                            slot="suffix"
                                            @click="openShoudf">
                                    </i>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="soldToAreaName" label="售达方区域" class="h-elformWrap-2" v-if="!showIsFree">
                                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
                            </el-form-item>
                            <el-form-item  prop="salesregion" label="送达方区域" class="h-elformWrap-2"  :rules="[
								  { required: true, message: '请输入送达方区域', trigger: 'change'},
								]"  v-if="!showIsFree">
                                    <brselect clearable category="YlSalesArea" :v="order.salesregion"
                                          v-model="order.salesregion"></brselect>
                             </el-form-item>

                            <el-form-item prop="customerChannelCode" label="客户渠道" :rules="[
								  { required: true, message: '请输入客户渠道', trigger: 'change'},
								]" class="h-elformWrap-2">
                                <el-select v-model="order.customerChannelCode" placeholder="请选择" style="width:100%">
                                    <el-option v-for="item in customerChannelListFilter"
                                               :key="item.code"
                                               :label="item.name"
                                               :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item prop="isStockUp" label="是否备货" :rules="[
								  { required: true, message: '请输入是否备货', trigger: 'change'},
								]" class="h-elformWrap-2" v-if="!showIsFree">
                                <brselect clearable category="shifou_keyong" :v="order.isStockUp"
                                          v-model="order.isStockUp"></brselect>
                            </el-form-item>
                            <el-form-item prop="toCompanyname" label="收货单位" :rules="[
								  { required: true, message: '请输入收货单位', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                <el-input v-model="order.toCompanyname" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="contactName" label="收货联系人" :rules="[
								  { required: true, message: '请输入收货联系人', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                <el-input v-model="order.contactName" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="选择收货地址"
                                          readonly
                                          :rules="[{ required: true, message: '请输入选择收货地址', trigger:['change', ' blur','input']}]"
                                          prop="toAddress" class="h-elformWrap-2">
                                <el-input clearable v-model="order.toAddress" readonly style="width:100%;">
                                    <i
                                            class="el-icon-search el-input__icon"
                                            slot="suffix"
                                            @click="selectAreadialog">
                                    </i>
                                </el-input>
                            </el-form-item>

                            <el-form-item label="联系电话" width="300" :rules="[
								  { required: true, message: '请输入联系电话', trigger: 'blur'},
								  { required: true, pattern: /^((\d+-\d+?)|(\d+))$/, message: '请输入正确的电话号码', trigger: 'blur' }
								]" class="h-elformWrap-2" prop="firsttelephone">
                                <div class="block">
                                    <el-input v-model="order.firsttelephone" placeholder="请输入"
                                    ></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item
                                    label="期望收货日期"
                                    class="h-elformWrap-2"
                                    width="100%"
                                    :rules="[
								  { required: true, message: '请输入期望收货日期', trigger: 'blur'},
								]"
                                    prop="receivedTime">
                                <div class="block">
                                    <el-date-picker
                                            v-model="order.receivedTime"
                                            type="date"
                                            :clearable="false"
                                            value-format="yyyy-MM-dd"
                                            placeholder="--请先选择收货地址--"
                                            :readonly="openReceivedTimedisabled"
                                            :picker-options="startDateLimit">
                                    </el-date-picker>
                                </div>
                            </el-form-item>

                            <el-form-item prop="currencyCode" label="币种" :rules="[
								  { required: true, message: '请输入币种', trigger: 'change'},
								]" class="h-elformWrap-2">
                                <mdmselect clearable category="YLCurrency"
                                           :showcode="true"
                                           disabled
                                           :v="order.currencyCode"
                                           v-model="order.currencyCode"></mdmselect>
                            </el-form-item>
                            <el-form-item prop="kucun" label="库位" :rules="[
								  { required: true, message: '请选择库位', trigger: 'change'},
								]"   class="h-elformWrap-2">
                                <brselect clearable category="order_wx_kuwei"
                                          :v="order.kucun"
                                          v-model="order.kucun"></brselect>
                            </el-form-item>
                            <el-form-item label="是否协同收入" class="h-elformWrap-2" v-if="!showXietong" required>
                              <brselect clearable category="is_xietong" :v="order.isXietong" v-model="order.isXietong"></brselect>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
            <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
            <div class="h-table h-mrt30 " style="margin: 10px 20px 0 10px;">
                <div class="h-pieceTitle2 message" style="margin-bottom: 0.3rem;">
                    <h1 class="h1">产品信息</h1>
                    <el-button size="small" type="primary"
                               icon="el-icon-circle-plus"
                               style="margin-left: 50px;"
                               @click="showProcuct1" v-if="showaddProductRow">选择产品
                    </el-button>
                </div>
                <div v-if="productlist9390.length>0" style="margin-bottom: 20px;">
                    <span style="color: #4a4a4a">青岛海尔生物医疗股份有限公司(9390)</span>
                    <el-table
                            ref="multipleTable"
                            :data="productlist9390"
                            stripe
							border
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="#"
                                width="40">
                        </el-table-column>
                        <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="产品编码"
                                min-width="130">
                        </el-table-column>
                        <el-table-column
                                min-width="150"
                                prop="materialName"
                                :show-overflow-tooltip="true"
                                label="产品名称">
                        </el-table-column>
                        <el-table-column
                                min-width="150"
                                prop="oemDesc"
                                :show-overflow-tooltip="true"
                                label="规格型号">
                        </el-table-column>
                        <el-table-column
                                prop="factory"
                                min-width="100"
                                label="产地">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.factory}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zhifakufa"
                                label="直发/库发"
                                width="120"
                                :formatter='formatterZhifakufa'
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                label="订单数量"
                                min-width="120">
                            <template slot-scope="scope">
                                <el-input
                                        v-model="scope.row.proNumber"
                                        placeholder="请输入"
                                        class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proBenchmarkPrice"
                                :label="priceName"
                                min-width="150">
                        </el-table-column>
                        <el-table-column
                                prop="expoPrice"
                                label="销售单价"
                                min-width="120" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.expoPrice"
                                          @keyup.native='keyupEvent($event,input)'
                                          :readonly="scope.row.expoPriceReadonly"
                                          placeholder="请输入"
                                          class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="specialPrice"
                                label="特价"
                                min-width="120"
                        >
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.specialOfferCode"
                                           @change="changeTejia($event,scope.row)"
                                           placeholder="请选择" clearable>
                                    <el-option
                                            v-for="item in scope.row.tjlist"
                                            :key="item.tjdtid"
                                            :label="item.tejia"
                                            :value="item.tjdtid">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="specialPriceNum"
                                label="特价余量"
                                min-width="120"
                        >
                        </el-table-column>
                        <el-table-column
                                         prop="finalPrice"
                                         label="成交价"
                                         min-width="130">
                            <template slot-scope="scope">
                                {{ scope.row.finalPrice = new big(scope.row.specialPrice || scope.row.expoPrice || scope.row.proBenchmarkPrice).plus(scope.row.extraPrice||0).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="jinejjz"
                                label="净价值"
                                min-width="110">
                            <template slot-scope="scope">
                                {{ scope.row.jinejjz = new
                                big(scope.row.finalPrice).times(scope.row.proNumber||0).div(1.13).toFixed(2).toString()}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="totalprice"
                                label="总价"
                                min-width="130"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.totalprice =  new big(scope.row.proNumber ||
                                0).times((scope.row.finalPrice||0)).toFixed(2).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="measure"
                                label="尺寸(长宽高)"
                                min-width="120"
                                :show-overflow-tooltip="true" >
                            <template slot-scope="scope">
                                {{ scope.row.measure }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" v-if="showdelProductRow" width="100" fixed="right">
                            <template slot-scope="scope">
                               <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="deleteThis(scope.row)">
                                    删除
                                </el-button>
								<!-- <div class="l-operationBox">
									<span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row)"></span>
								</div> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="jieguo" v-if="!showIsFree">
                        <span class="jieguo_label">订单总价</span>
                        <span class="jieguo_value">{{  order9390.orderPrice }}</span>
                        <span class="jieguo_label">现金余额</span>
                        <span class="jieguo_value">{{ order9390.xianjye }}</span>
                        <span class="jieguo_label">现金占用</span>
                        <span class="jieguo_value">{{ order9390.orderPriceXj = new big(this.order9390.orderPrice||0).minus(order9390.orderPriceXd||0).toString() }}</span>
                        <span class="jieguo_label">现金欠款</span>
                        <span class="jieguo_value">{{order9390.orderPriceXjQk = ((new big(order9390.xianjye||0).minus(order9390.orderPriceXj||0))>0 ? 0:(new big(order9390.xianjye||0).minus(order9390.orderPriceXj||0).toString())) }}</span>
                        <span class="jieguo_label">信贷选择</span>
                        <span class="jieguo_value">
                        <el-select v-model="order9390.creditid" clearable
                                   placeholder="请选择" @change="creditChange($event,'9390')">
                            <el-option
                                    v-for="item in order9390.creditData"
                                    :key="item.id"
                                    :label="`信贷总额：${ item.quota }+信贷账期：${ item.paymentdate }天`"
                                    :value="item.id">
                                <div style="color: #8492a6; font-size: 12px">
                                    <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                                    <i style="float: right; ">信贷截止日期：{{ item.validitydate }}</i>
                                </div>
                            </el-option>
                        </el-select>
                    </span>
                        <span class="jieguo_label">信贷占用</span>
                        <span class="jieguo_value">{{ order9390.orderPriceXd }}</span>
                        <span class="jieguo_label">净价值</span>
                        <span class="jieguo_value">{{order9390.orderNetWorth}}</span>
                    </div>

                </div>

                <div v-if="productlist1D90.length>0" style="margin-bottom: 20px;">
                    <span style="color: #4a4a4a">海乐苗（青岛）智能物联有限公司(1D90)</span>
                    <el-table
                            ref="multipleTable"
                            :data="productlist1D90"
                            stripe
                            border
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="#"
                                width="40">
                        </el-table-column>
                        <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="产品编码"
                                min-width="130">
                        </el-table-column>
                        <el-table-column
                                min-width="150"
                                prop="materialName"
                                :show-overflow-tooltip="true"
                                label="产品名称">
                        </el-table-column>
                        <el-table-column
                                prop="factory"
                                min-width="100"
                                label="产地">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.factory}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zhifakufa"
                                label="直发/库发"
                                width="120"
                                :formatter='formatterZhifakufa'
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                label="订单数量"
                                min-width="120">
                            <template slot-scope="scope">
                                <el-input
                                        v-model="scope.row.proNumber"
                                        placeholder="请输入"
                                        class="DshuR"
                                        oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')"
                                        auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proBenchmarkPrice"
                                :label="priceName"
                                min-width="150">
                        </el-table-column>
                        <el-table-column
                                prop="expoPrice"
                                label="销售单价"
                                min-width="120" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.expoPrice"
                                          @keyup.native='keyupEvent($event,input)'
                                          :readonly="scope.row.expoPriceReadonly"
                                          placeholder="请输入"
                                          class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="specialPrice"
                                label="特价"
                                min-width="120"
                        >
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.specialOfferCode"
                                           @change="changeTejia($event,scope.row)"
                                           placeholder="请选择" clearable>
                                    <el-option
                                            v-for="item in scope.row.tjlist"
                                            :key="item.tjdtid"
                                            :label="item.tejia"
                                            :value="item.tjdtid">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="specialPriceNum"
                                label="特价余量"
                                min-width="120"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="finalPrice"
                                label="成交价"
                                min-width="130">
                            <template slot-scope="scope">
                                {{ scope.row.finalPrice = new big(scope.row.specialPrice || scope.row.expoPrice || scope.row.proBenchmarkPrice).plus(scope.row.extraPrice||0).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="jinejjz"
                                label="净价值"
                                min-width="110">
                            <template slot-scope="scope">
                                {{ scope.row.jinejjz = new
                                big(scope.row.finalPrice).times(scope.row.proNumber||0).div(1.13).toFixed(2).toString()}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="totalprice"
                                label="总价"
                                min-width="130"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.totalprice =  new big(scope.row.proNumber ||
                                0).times((scope.row.finalPrice||0)).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="measure"
                                label="尺寸(长宽高)"
                                min-width="120"
                                :show-overflow-tooltip="true" >
                            <template slot-scope="scope">
                                {{ scope.row.measure }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" v-if="showdelProductRow" width="100" fixed="right">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="deleteThis(scope.row)">
                                    删除
                                </el-button>
                                <!-- <div class="l-operationBox">
                                    <span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row)"></span>
                                </div> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="jieguo" v-if="!showIsFree">
                        <span class="jieguo_label">订单总价</span>
                        <span class="jieguo_value">{{  order1D90.orderPrice }}</span>
                        <span class="jieguo_label">现金余额</span>
                        <span class="jieguo_value">{{ order1D90.xianjye }}</span>
                        <span class="jieguo_label">现金占用</span>
                        <span class="jieguo_value">{{ order1D90.orderPriceXj = new big(this.order1D90.orderPrice||0).minus(order1D90.orderPriceXd||0).toString() }}</span>
                        <span class="jieguo_label">现金欠款</span>
                        <span class="jieguo_value">{{order1D90.orderPriceXjQk = ((new big(order1D90.xianjye||0).minus(order1D90.orderPriceXj||0))>0 ? 0:(new big(order1D90.xianjye||0).minus(order1D90.orderPriceXj||0).toString())) }}</span>
                        <span class="jieguo_label">信贷选择</span>
                        <span class="jieguo_value">
                        <el-select v-model="order1D90.creditid" clearable
                                   placeholder="请选择" @change="creditChange($event,'1D90')">
                            <el-option
                                    v-for="item in order1D90.creditData"
                                    :key="item.id"
                                    :label="`信贷总额：${ item.quota }+信贷账期：${ item.paymentdate }天`"
                                    :value="item.id">
                                <div style="color: #8492a6; font-size: 12px">
                                    <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                                    <i style="float: right; ">信贷截止日期：{{ item.validitydate }}</i>
                                </div>
                            </el-option>
                        </el-select>
                    </span>
                        <span class="jieguo_label">信贷占用</span>
                        <span class="jieguo_value">{{ order1D90.orderPriceXd }}</span>
                        <span class="jieguo_label">净价值</span>
                        <span class="jieguo_value">{{order1D90.orderNetWorth}}</span>
                    </div>

                </div>

                <div v-if="productlist1RK0.length>0" style="margin-bottom: 20px;">
                    <span style="color: #4a4a4a">青岛海尔生物医疗设备有限公司(1RK0)</span>
                    <el-table
                            ref="multipleTable"
                            :data="productlist1RK0"
                            stripe
                            border
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="#"
                                width="40">
                        </el-table-column>
                        <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="产品编码"
                                min-width="130">
                        </el-table-column>
                        <el-table-column
                                min-width="150"
                                prop="materialName"
                                :show-overflow-tooltip="true"
                                label="产品名称">
                        </el-table-column>
                        <el-table-column
                                prop="factory"
                                min-width="100"
                                label="产地">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.factory}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zhifakufa"
                                label="直发/库发"
                                width="120"
                                :formatter='formatterZhifakufa'
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                label="订单数量"
                                min-width="120">
                            <template slot-scope="scope">
                                <el-input
                                        v-model="scope.row.proNumber"
                                        placeholder="请输入"
                                        class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proBenchmarkPrice"
                                :label="priceName"
                                min-width="150">
                        </el-table-column>
                        <el-table-column
                                prop="expoPrice"
                                label="销售单价"
                                min-width="120" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.expoPrice"
                                          @keyup.native='keyupEvent($event,input)'
                                          :readonly="scope.row.expoPriceReadonly"
                                          placeholder="请输入"
                                          class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="specialPrice"
                                label="特价"
                                min-width="120"
                        >
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.specialOfferCode"
                                           @change="changeTejia($event,scope.row)"
                                           placeholder="请选择" clearable>
                                    <el-option
                                            v-for="item in scope.row.tjlist"
                                            :key="item.tjdtid"
                                            :label="item.tejia"
                                            :value="item.tjdtid">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="specialPriceNum"
                                label="特价余量"
                                min-width="120"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="finalPrice"
                                label="成交价"
                                min-width="130">
                            <template slot-scope="scope">
                                {{ scope.row.finalPrice = new big(scope.row.specialPrice || scope.row.expoPrice || scope.row.proBenchmarkPrice).plus(scope.row.extraPrice||0).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="jinejjz"
                                label="净价值"
                                min-width="110">
                            <template slot-scope="scope">
                                {{ scope.row.jinejjz = new
                                big(scope.row.finalPrice).times(scope.row.proNumber||0).div(1.13).toFixed(2).toString()}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="totalprice"
                                label="总价"
                                min-width="130"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.totalprice =  new big(scope.row.proNumber ||
                                0).times((scope.row.finalPrice||0)).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="measure"
                                label="尺寸(长宽高)"
                                min-width="120"
                                :show-overflow-tooltip="true" >
                            <template slot-scope="scope">
                                {{ scope.row.measure }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" v-if="showdelProductRow" width="100" fixed="right">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="deleteThis(scope.row)">
                                    删除
                                </el-button>
                                <!-- <div class="l-operationBox">
                                    <span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row)"></span>
                                </div> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="jieguo" v-if="!showIsFree">
                        <span class="jieguo_label">订单总价</span>
                        <span class="jieguo_value">{{  order1RK0.orderPrice }}</span>
                        <span class="jieguo_label">现金余额</span>
                        <span class="jieguo_value">{{ order1RK0.xianjye }}</span>
                        <span class="jieguo_label">现金占用</span>
                        <span class="jieguo_value">{{ order1RK0.orderPriceXj = new big(this.order1RK0.orderPrice||0).minus(order1RK0.orderPriceXd||0).toString() }}</span>
                        <span class="jieguo_label">现金欠款</span>
                        <span class="jieguo_value">{{order1RK0.orderPriceXjQk = ((new big(order1RK0.xianjye||0).minus(order1RK0.orderPriceXj||0))>0 ? 0:(new big(order1RK0.xianjye||0).minus(order1RK0.orderPriceXj||0).toString())) }}</span>
                        <span class="jieguo_label">信贷选择</span>
                        <span class="jieguo_value">
                        <el-select v-model="order1RK0.creditid" clearable
                                   placeholder="请选择" @change="creditChange($event,'1RK0')">
                            <el-option
                                    v-for="item in order1RK0.creditData"
                                    :key="item.id"
                                    :label="`信贷总额：${ item.quota }+信贷账期：${ item.paymentdate }天`"
                                    :value="item.id">
                                <div style="color: #8492a6; font-size: 12px">
                                    <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                                    <i style="float: right; ">信贷截止日期：{{ item.validitydate }}</i>
                                </div>
                            </el-option>
                        </el-select>
                    </span>
                        <span class="jieguo_label">信贷占用</span>
                        <span class="jieguo_value">{{ order1RK0.orderPriceXd }}</span>
                        <span class="jieguo_label">净价值</span>
                        <span class="jieguo_value">{{order1RK0.orderNetWorth}}</span>
                    </div>

                </div>

                <div v-if="productlist0PN0.length>0" style="margin-bottom: 20px;">
                    <span style="color: #4a4a4a">四川海盛杰低温科技有限公司(0PN0)</span>
                    <el-table
                            ref="multipleTable"
                            :data="productlist0PN0"
                            stripe
                            border
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="#"
                                width="40">
                        </el-table-column>
                        <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="产品编码"
                                min-width="130">
                        </el-table-column>
                        <el-table-column
                                min-width="150"
                                prop="materialName"
                                :show-overflow-tooltip="true"
                                label="产品名称">
                        </el-table-column>
                        <el-table-column
                                prop="factory"
                                min-width="100"
                                label="产地">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.factory}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zhifakufa"
                                label="直发/库发"
                                width="120"
                                :formatter='formatterZhifakufa'
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                label="订单数量"
                                min-width="120">
                            <template slot-scope="scope">
                                <el-input
                                        v-model="scope.row.proNumber"
                                        placeholder="请输入"
                                        class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proBenchmarkPrice"
                                :label="priceName"
                                min-width="150">
                        </el-table-column>
                        <el-table-column
                                prop="expoPrice"
                                label="销售单价"
                                min-width="120" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.expoPrice"
                                          @keyup.native='keyupEvent($event,input)'
                                          :readonly="scope.row.expoPriceReadonly"
                                          placeholder="请输入"
                                          class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="specialPrice"
                                label="特价"
                                min-width="120"
                        >
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.specialOfferCode"
                                           @change="changeTejia($event,scope.row)"
                                           placeholder="请选择" clearable>
                                    <el-option
                                            v-for="item in scope.row.tjlist"
                                            :key="item.tjdtid"
                                            :label="item.tejia"
                                            :value="item.tjdtid">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="specialPriceNum"
                                label="特价余量"
                                min-width="120"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="finalPrice"
                                label="成交价"
                                min-width="130">
                            <template slot-scope="scope">
                                {{ scope.row.finalPrice = new big(scope.row.specialPrice || scope.row.expoPrice || scope.row.proBenchmarkPrice).plus(scope.row.extraPrice||0).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="jinejjz"
                                label="净价值"
                                min-width="110">
                            <template slot-scope="scope">
                                {{ scope.row.jinejjz = new
                                big(scope.row.finalPrice).times(scope.row.proNumber||0).div(1.13).toFixed(2).toString()}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="totalprice"
                                label="总价"
                                min-width="130"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.totalprice =  new big(scope.row.proNumber ||
                                0).times((scope.row.finalPrice||0)).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="measure"
                                label="尺寸(长宽高)"
                                min-width="120"
                                :show-overflow-tooltip="true" >
                            <template slot-scope="scope">
                                {{ scope.row.measure }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" v-if="showdelProductRow" width="100" fixed="right">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="deleteThis(scope.row)">
                                    删除
                                </el-button>
                                <!-- <div class="l-operationBox">
                                    <span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row)"></span>
                                </div> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="jieguo" v-if="!showIsFree">
                        <span class="jieguo_label">订单总价</span>
                        <span class="jieguo_value">{{  order0PN0.orderPrice }}</span>
                        <span class="jieguo_label">现金余额</span>
                        <span class="jieguo_value">{{ order0PN0.xianjye }}</span>
                        <span class="jieguo_label">现金占用</span>
                        <span class="jieguo_value">{{ order0PN0.orderPriceXj = new big(this.order0PN0.orderPrice||0).minus(order0PN0.orderPriceXd||0).toString() }}</span>
                        <span class="jieguo_label">现金欠款</span>
                        <span class="jieguo_value">{{order0PN0.orderPriceXjQk = ((new big(order0PN0.xianjye||0).minus(order0PN0.orderPriceXj||0))>0 ? 0:(new big(order0PN0.xianjye||0).minus(order0PN0.orderPriceXj||0).toString())) }}</span>
                        <span class="jieguo_label">信贷选择</span>
                        <span class="jieguo_value">
                        <el-select v-model="order0PN0.creditid" clearable
                                   placeholder="请选择" @change="creditChange($event,'0PN0')">
                            <el-option
                                    v-for="item in order0PN0.creditData"
                                    :key="item.id"
                                    :label="`信贷总额：${ item.quota }+信贷账期：${ item.paymentdate }天`"
                                    :value="item.id">
                                <div style="color: #8492a6; font-size: 12px">
                                    <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                                    <i style="float: right; ">信贷截止日期：{{ item.validitydate }}</i>
                                </div>
                            </el-option>
                        </el-select>
                    </span>
                        <span class="jieguo_label">信贷占用</span>
                        <span class="jieguo_value">{{ order0PN0.orderPriceXd }}</span>
                        <span class="jieguo_label">净价值</span>
                        <span class="jieguo_value">{{order0PN0.orderNetWorth}}</span>
                    </div>

                </div>
                <div v-if="productlist1R60.length>0" style="margin-bottom: 20px;">
                    <span style="color: #4a4a4a">苏州康盛生物有限公司(1R60)</span>
                    <el-table
                        ref="multipleTable"
                        :data="productlist1R60"
                        stripe
                        border
                        style="width: 100%">
                        <el-table-column
                            type="index"
                            label="#"
                            width="40">
                        </el-table-column>
                        <el-table-column
                            prop="proModelName"
                            label="产品大类"
                            :show-overflow-tooltip="true"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            prop="materialCode"
                            label="产品编码"
                            min-width="130">
                        </el-table-column>
                        <el-table-column
                            min-width="150"
                            prop="materialName"
                            :show-overflow-tooltip="true"
                            label="产品名称">
                        </el-table-column>
                        <el-table-column
                            prop="factory"
                            min-width="100"
                            label="产地">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.factory}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="zhifakufa"
                            label="直发/库发"
                            width="120"
                            :formatter='formatterZhifakufa'
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="proNumber"
                            label="订单数量"
                            min-width="120">
                            <template slot-scope="scope">
                                <el-input
                                    v-model="scope.row.proNumber"
                                    placeholder="请输入"
                                    class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="proBenchmarkPrice"
                            :label="priceName"
                            min-width="150">
                        </el-table-column>
                        <el-table-column
                            prop="expoPrice"
                            label="销售单价"
                            min-width="120" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.expoPrice"
                                          @keyup.native='keyupEvent($event,input)'
                                          :readonly="scope.row.expoPriceReadonly"
                                          placeholder="请输入"
                                          class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="tejieshowflag"
                            prop="specialPrice"
                            label="特价"
                            min-width="120"
                        >
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.specialOfferCode"
                                           @change="changeTejia($event,scope.row)"
                                           placeholder="请选择" clearable>
                                    <el-option
                                        v-for="item in scope.row.tjlist"
                                        :key="item.tjdtid"
                                        :label="item.tejia"
                                        :value="item.tjdtid">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="tejieshowflag"
                            prop="specialPriceNum"
                            label="特价余量"
                            min-width="120"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="finalPrice"
                            label="成交价"
                            min-width="130">
                            <template slot-scope="scope">
                                {{ scope.row.finalPrice = new big(scope.row.specialPrice || scope.row.expoPrice || scope.row.proBenchmarkPrice).plus(scope.row.extraPrice||0).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="jinejjz"
                            label="净价值"
                            min-width="110">
                            <template slot-scope="scope">
                                {{ scope.row.jinejjz = new
                            big(scope.row.finalPrice).times(scope.row.proNumber||0).div(1.13).toFixed(2).toString()}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="totalprice"
                            label="总价"
                            min-width="130"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.totalprice =  new big(scope.row.proNumber ||
                                0).times((scope.row.finalPrice||0)).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="measure"
                            label="尺寸(长宽高)"
                            min-width="120"
                            :show-overflow-tooltip="true" >
                            <template slot-scope="scope">
                                {{ scope.row.measure }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" v-if="showdelProductRow" width="100" fixed="right">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="deleteThis(scope.row)">
                                    删除
                                </el-button>
                                <!-- <div class="l-operationBox">
                                    <span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row)"></span>
                                </div> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="jieguo" v-if="!showIsFree">
                        <span class="jieguo_label">订单总价</span>
                        <span class="jieguo_value">{{  order1R60.orderPrice }}</span>
                        <span class="jieguo_label">现金余额</span>
                        <span class="jieguo_value">{{ order1R60.xianjye }}</span>
                        <span class="jieguo_label">现金占用</span>
                        <span class="jieguo_value">{{ order1R60.orderPriceXj = new big(this.order1R60.orderPrice||0).minus(order1R60.orderPriceXd||0).toString() }}</span>
                        <span class="jieguo_label">现金欠款</span>
                        <span class="jieguo_value">{{order1R60.orderPriceXjQk = ((new big(order1R60.xianjye||0).minus(order1R60.orderPriceXj||0))>0 ? 0:(new big(order1R60.xianjye||0).minus(order1R60.orderPriceXj||0).toString())) }}</span>
                        <span class="jieguo_label">信贷选择</span>
                        <span class="jieguo_value">
                        <el-select v-model="order1R60.creditid" clearable
                                   placeholder="请选择" @change="creditChange($event,'1R60')">
                            <el-option
                                v-for="item in order1R60.creditData"
                                :key="item.id"
                                :label="`信贷总额：${ item.quota }+信贷账期：${ item.paymentdate }天`"
                                :value="item.id">
                                <div style="color: #8492a6; font-size: 12px">
                                    <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                                    <i style="float: right; ">信贷截止日期：{{ item.validitydate }}</i>
                                </div>
                            </el-option>
                        </el-select>
                    </span>
                        <span class="jieguo_label">信贷占用</span>
                        <span class="jieguo_value">{{ order1R60.orderPriceXd }}</span>
                        <span class="jieguo_label">净价值</span>
                        <span class="jieguo_value">{{order1R60.orderNetWorth}}</span>
                    </div>

                </div>
                <div v-if="productlist44U0.length>0" style="margin-bottom: 20px;">
                    <span style="color: #4a4a4a">上海元析仪器有限公司(44U0)</span>
                    <el-table
                        ref="multipleTable"
                        :data="productlist44U0"
                        stripe
                        border
                        style="width: 100%">
                        <el-table-column
                            type="index"
                            label="#"
                            width="40">
                        </el-table-column>
                        <el-table-column
                            prop="proModelName"
                            label="产品大类"
                            :show-overflow-tooltip="true"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            prop="materialCode"
                            label="产品编码"
                            min-width="130">
                        </el-table-column>
                        <el-table-column
                            min-width="150"
                            prop="materialName"
                            :show-overflow-tooltip="true"
                            label="产品名称">
                        </el-table-column>
                        <el-table-column
                            prop="factory"
                            min-width="100"
                            label="产地">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.factory}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="zhifakufa"
                            label="直发/库发"
                            width="120"
                            :formatter='formatterZhifakufa'
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="proNumber"
                            label="订单数量"
                            min-width="120">
                            <template slot-scope="scope">
                                <el-input
                                    v-model="scope.row.proNumber"
                                    placeholder="请输入"
                                    class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="proBenchmarkPrice"
                            :label="priceName"
                            min-width="150">
                        </el-table-column>
                        <el-table-column
                            prop="expoPrice"
                            label="销售单价"
                            min-width="120" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.expoPrice"
                                          @keyup.native='keyupEvent($event,input)'
                                          :readonly="scope.row.expoPriceReadonly"
                                          placeholder="请输入"
                                          class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="tejieshowflag"
                            prop="specialPrice"
                            label="特价"
                            min-width="120"
                        >
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.specialOfferCode"
                                           @change="changeTejia($event,scope.row)"
                                           placeholder="请选择" clearable>
                                    <el-option
                                        v-for="item in scope.row.tjlist"
                                        :key="item.tjdtid"
                                        :label="item.tejia"
                                        :value="item.tjdtid">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="tejieshowflag"
                            prop="specialPriceNum"
                            label="特价余量"
                            min-width="120"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="finalPrice"
                            label="成交价"
                            min-width="130">
                            <template slot-scope="scope">
                                {{ scope.row.finalPrice = new big(scope.row.specialPrice || scope.row.expoPrice || scope.row.proBenchmarkPrice).plus(scope.row.extraPrice||0).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="jinejjz"
                            label="净价值"
                            min-width="110">
                            <template slot-scope="scope">
                                {{ scope.row.jinejjz = new
                            big(scope.row.finalPrice).times(scope.row.proNumber||0).div(1.13).toFixed(2).toString()}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="totalprice"
                            label="总价"
                            min-width="130"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.totalprice =  new big(scope.row.proNumber ||
                                0).times((scope.row.finalPrice||0)).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="note1"
                                label="备注"
                                min-width="160"
                        >
                            <template slot-scope="scope">
                                <el-input class="DshuR" v-model="scope.row.note1"
                                          placeholder=""
                                          auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="measure"
                            label="尺寸(长宽高)"
                            min-width="120"
                            :show-overflow-tooltip="true" >
                            <template slot-scope="scope">
                                {{ scope.row.measure }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" v-if="showdelProductRow" width="100" fixed="right">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="deleteThis(scope.row)">
                                    删除
                                </el-button>
                                <!-- <div class="l-operationBox">
                                    <span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row)"></span>
                                </div> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="jieguo" v-if="!showIsFree">
                        <span class="jieguo_label">订单总价</span>
                        <span class="jieguo_value">{{  order44U0.orderPrice }}</span>
                        <span class="jieguo_label">现金余额</span>
                        <span class="jieguo_value">{{ order44U0.xianjye }}</span>
                        <span class="jieguo_label">现金占用</span>
                        <span class="jieguo_value">{{ order44U0.orderPriceXj = new big(this.order44U0.orderPrice||0).minus(order44U0.orderPriceXd||0).toString() }}</span>
                        <span class="jieguo_label">现金欠款</span>
                        <span class="jieguo_value">{{order44U0.orderPriceXjQk = ((new big(order44U0.xianjye||0).minus(order44U0.orderPriceXj||0))>0 ? 0:(new big(order44U0.xianjye||0).minus(order44U0.orderPriceXj||0).toString())) }}</span>
                        <span class="jieguo_label">信贷选择</span>
                        <span class="jieguo_value">
                        <el-select v-model="order44U0.creditid" clearable
                                   placeholder="请选择" @change="creditChange($event,'44U0')">
                            <el-option
                                v-for="item in order44U0.creditData"
                                :key="item.id"
                                :label="`信贷总额：${ item.quota }+信贷账期：${ item.paymentdate }天`"
                                :value="item.id">
                                <div style="color: #8492a6; font-size: 12px">
                                    <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                                    <i style="float: right; ">信贷截止日期：{{ item.validitydate }}</i>
                                </div>
                            </el-option>
                        </el-select>
                    </span>
                        <span class="jieguo_label">信贷占用</span>
                        <span class="jieguo_value">{{ order44U0.orderPriceXd }}</span>
                        <span class="jieguo_label">净价值</span>
                        <span class="jieguo_value">{{order44U0.orderNetWorth}}</span>
                    </div>

                </div>

                <div v-if="productlist1S00.length>0" style="margin-bottom: 20px;">
                    <span style="color: #4a4a4a">海尔生物医疗科技（苏州）有限公司(1S00)</span>
                    <el-table
                        ref="multipleTable"
                        :data="productlist1S00"
                        stripe
                        border
                        style="width: 100%">
                        <el-table-column
                            type="index"
                            label="#"
                            width="40">
                        </el-table-column>
                        <el-table-column
                            prop="proModelName"
                            label="产品大类"
                            :show-overflow-tooltip="true"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            prop="materialCode"
                            label="产品编码"
                            min-width="130">
                        </el-table-column>
                        <el-table-column
                            min-width="150"
                            prop="materialName"
                            :show-overflow-tooltip="true"
                            label="产品名称">
                        </el-table-column>
                        <el-table-column
                            prop="factory"
                            min-width="100"
                            label="产地">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.factory}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="zhifakufa"
                            label="直发/库发"
                            width="120"
                            :formatter='formatterZhifakufa'
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="proNumber"
                            label="订单数量"
                            min-width="120">
                            <template slot-scope="scope">
                                <el-input
                                    v-model="scope.row.proNumber"
                                    placeholder="请输入"
                                    class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="proBenchmarkPrice"
                            :label="priceName"
                            min-width="150">
                        </el-table-column>
                        <el-table-column
                            prop="expoPrice"
                            label="销售单价"
                            min-width="120" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.expoPrice"
                                          @keyup.native='keyupEvent($event,input)'
                                          :readonly="scope.row.expoPriceReadonly"
                                          placeholder="请输入"
                                          class="DshuR" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="tejieshowflag"
                            prop="specialPrice"
                            label="特价"
                            min-width="120"
                        >
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.specialOfferCode"
                                           @change="changeTejia($event,scope.row)"
                                           placeholder="请选择" clearable>
                                    <el-option
                                        v-for="item in scope.row.tjlist"
                                        :key="item.tjdtid"
                                        :label="item.tejia"
                                        :value="item.tjdtid">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="tejieshowflag"
                            prop="specialPriceNum"
                            label="特价余量"
                            min-width="120"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="finalPrice"
                            label="成交价"
                            min-width="130">
                            <template slot-scope="scope">
                                {{ scope.row.finalPrice = new big(scope.row.specialPrice || scope.row.expoPrice || scope.row.proBenchmarkPrice).plus(scope.row.extraPrice||0).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="jinejjz"
                            label="净价值"
                            min-width="110">
                            <template slot-scope="scope">
                                {{ scope.row.jinejjz = new
                            big(scope.row.finalPrice).times(scope.row.proNumber||0).div(1.13).toFixed(2).toString()}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="totalprice"
                            label="总价"
                            min-width="130"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.totalprice =  new big(scope.row.proNumber ||
                                0).times((scope.row.finalPrice||0)).toString() }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="note1"
                            label="备注"
                            min-width="160"
                        >
                            <template slot-scope="scope">
                                <el-input class="DshuR" v-model="scope.row.note1"
                                          placeholder=""
                                          auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="measure"
                            label="尺寸(长宽高)"
                            min-width="120"
                            :show-overflow-tooltip="true" >
                            <template slot-scope="scope">
                                {{ scope.row.measure }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" v-if="showdelProductRow" width="100" fixed="right">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="deleteThis(scope.row)">
                                    删除
                                </el-button>
                                <!-- <div class="l-operationBox">
                                    <span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row)"></span>
                                </div> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="jieguo" v-if="!showIsFree">
                        <span class="jieguo_label">订单总价</span>
                        <span class="jieguo_value">{{  order1S00.orderPrice }}</span>
                        <span class="jieguo_label">现金余额</span>
                        <span class="jieguo_value">{{ order1S00.xianjye }}</span>
                        <span class="jieguo_label">现金占用</span>
                        <span class="jieguo_value">{{ order1S00.orderPriceXj = new big(this.order1S00.orderPrice||0).minus(order1S00.orderPriceXd||0).toString() }}</span>
                        <span class="jieguo_label">现金欠款</span>
                        <span class="jieguo_value">{{order1S00.orderPriceXjQk = ((new big(order1S00.xianjye||0).minus(order1S00.orderPriceXj||0))>0 ? 0:(new big(order1S00.xianjye||0).minus(order1S00.orderPriceXj||0).toString())) }}</span>
                        <span class="jieguo_label">信贷选择</span>
                        <span class="jieguo_value">
                        <el-select v-model="order1S00.creditid" clearable
                                   placeholder="请选择" @change="creditChange($event,'1S00')">
                            <el-option
                                v-for="item in order1S00.creditData"
                                :key="item.id"
                                :label="`信贷总额：${ item.quota }+信贷账期：${ item.paymentdate }天`"
                                :value="item.id">
                                <div style="color: #8492a6; font-size: 12px">
                                    <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                                    <i style="float: right; ">信贷截止日期：{{ item.validitydate }}</i>
                                </div>
                            </el-option>
                        </el-select>
                    </span>
                        <span class="jieguo_label">信贷占用</span>
                        <span class="jieguo_value">{{ order1S00.orderPriceXd }}</span>
                        <span class="jieguo_label">净价值</span>
                        <span class="jieguo_value">{{order1S00.orderNetWorth}}</span>
                    </div>

                </div>

            </div>
            <!-------------------------------------------------------产品信息-------------------------------------------------------------------->

            <!--------------------------------------------------------------------收货地址弹出框-------------------------------------------------------->
            <!--物料-->
            <wxwl
                    :visible.sync="showwuliaodialog1"
                    v-if="showwuliaodialog1"
                    @choseObj="choseWuliao1"
                    :usercode="order.soldToCode"
                    :ddlx="ddlx"
                    :xmcode="xmcode"
                    :currencyCode="order.currencyCode"
                    title="选择物料"/>
            <!--外销物料-->
            <waimaowxwl :visible.sync="showwuliaodialogWX"
                         v-if="showwuliaodialogWX"
                         @choseObj="choseWuliao1"
                         :ddlx="ddlx"
                         :xmcode="xmcode"
                         :usercode="order.soldToCode"
                         :currencyCode="order.currencyCode"
                         :country="order.shipToAreaCode"
                         title="选择预测单"/>

            <!--售达方-->
            <shoudf
                    :visible.sync="showshdfdialog"
                    v-if="showshdfdialog"
                    @choseObj="choseshoudf"
                    oneflag
                    :usercode="currentUser"
                    :xmcode="xmcode"
                    :ddlx="ddlx"
                    :xszz="order.saleGroupCode"
                    title="选择售达方"/>
            <!--地址信息-->
            <areaSelect
                    :visible.sync="showdizhiflag"
                    v-if="showdizhiflag"
                    @choseObj="choseDizhi"
            />
            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        </div>
        <div v-if="taskstatus=='0'">
            <div class="anniu" v-if="!resubmit">
                <el-row>
                    <el-button class="h-btn h-bBtn h-bgwhite" style="margin-right:10px;" @click="backtolist">返回</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>
                </el-row>
            </div>
            <div class="anniu" v-else="resubmit">
                <el-row>
                    <el-button class="h-btn h-bBtn h-bgwhite" style="margin-right:10px;" @click="backtolist">返回</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="resaveOrSubmit(20)">重新提交</el-button>
                    <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
                </el-row>
            </div>
        </div>
        <div class="anniu" v-if="taskstatus == '1'">
            <el-row>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="this.$store.dispatch('backToTaskIndex')">返回</el-button>
            </el-row>
        </div>
    </div>
</template>
<script>
    import big from 'big.js'
    import ss from '../../api/SystemService'
    import wxwl from '../../components/dialog/wxwl'
    import shoudf from '../../components/dialog/selectshdf'
    import waimaowxwl from '../../components/dialog/wxwl-waimao'

    export default {
        components: {
            wxwl, shoudf, waimaowxwl
        },
        filters: {
            gsname: function (v) {
                return _.find(this.allxszz, {code: v}).name;
            },
            numFilter(value) {
                let realVal = ''
                if (value) {
                    // 截取当前数据到小数点后两位
                    realVal = parseFloat(value).toFixed(2) * 100 + '%'
                } else {
                    realVal = '--'
                }
                return realVal
            }
        },
        data() {
            return {
                submitChongfuFlag:true,
                priceForShow: "",
                priceName: "基准价",
                contract: "",
                showRent: false,
                contractName: "",
                contractStarttime: "",
                contractEndtime: "",
                checked: true,
                showOrhide: false,
                status: 1,
                toshow: 'createNxOrder2',
                showSamplePro: false,
                showIsFree: false,
				showIsFreeSh:false,
                resubmit: false,
                instid: null,
                taskstatus: 0,
                //时候售后订单
                showshouhouflag: false,
                showhistory: false,
                selectDailishang: true,
                showwuliaodialog1: false,
                showwuliaodialogWX: false,
                showshdfdialog: false,
                showdizhiflag: false,
                currentUser: null,
                showdelProductRow: true,
                showaddProductRow: true,

                //上海的采购毛利率
                showShcgmll: false,
                //是否可以选择时间
                startDateLimit: {
                    disabledDate: (time) => {
                        return time.getTime() < Date.now() + 5 * 24 * 3600 * 1000
                    }
                },
                openReceivedTimedisabled: true,
                //特价
                tejieshowflag: false,
                //定制展示
                dingzhishowflag: false,
                //现金余额
                cashBalance: 0,
                //展会项目不展示合同号
                contractflag: true,
                xmcode: null,
                //销售组织
                allxszz: [],
                //订单类型
                ddlx: null,
                //是否直单用户
                zhidanflag:0,

                //行项目
                productlist9390: [],
                productlist9370: [],
                productlist9391: [],
                productlist1D90: [],
                productlist1RK0: [],
                productlist0PN0: [],
                productlist1R60: [],
                productlist44U0: [],
                productlist1S00: [],

                //对象
                order9390: {
                    orderPrice: 0, // 订单总价
                    xianjye: 0,
                    taxCat: 0,
                    taxRate: 0,
                    orderPriceXj: 0, // 订单现金占用
                    orderPriceXjQk: 0, // 订单现金欠款
                    creditid: null, // 信贷id
                    orderPriceXd: 0, // 订单信贷占用
                    orderNetWorth: 0, // 订单净价值
                    creditData: [],
                },

                order1D90: {
                    orderPrice: 0, // 订单总价
                    xianjye: 0,
                    taxCat: 0,
                    taxRate: 0,
                    orderPriceXj: 0, // 订单现金占用
                    orderPriceXjQk: 0, // 订单现金欠款
                    creditid: null, // 信贷id
                    orderPriceXd: 0, // 订单信贷占用
                    orderNetWorth: 0, // 订单净价值
                    creditData: [],
                },

                order1RK0: {
                    orderPrice: 0, // 订单总价
                    xianjye: 0,
                    taxCat: 0,
                    taxRate: 0,
                    orderPriceXj: 0, // 订单现金占用
                    orderPriceXjQk: 0, // 订单现金欠款
                    creditid: null, // 信贷id
                    orderPriceXd: 0, // 订单信贷占用
                    orderNetWorth: 0, // 订单净价值
                    creditData: [],
                },

                order0PN0: {
                    orderPrice: 0, // 订单总价
                    xianjye: 0,
                    taxCat: 0,
                    taxRate: 0,
                    orderPriceXj: 0, // 订单现金占用
                    orderPriceXjQk: 0, // 订单现金欠款
                    creditid: null, // 信贷id
                    orderPriceXd: 0, // 订单信贷占用
                    orderNetWorth: 0, // 订单净价值
                    creditData: [],
                },
                order1R60: {
                    orderPrice: 0, // 订单总价
                    xianjye: 0,
                    taxCat: 0,
                    taxRate: 0,
                    orderPriceXj: 0, // 订单现金占用
                    orderPriceXjQk: 0, // 订单现金欠款
                    creditid: null, // 信贷id
                    orderPriceXd: 0, // 订单信贷占用
                    orderNetWorth: 0, // 订单净价值
                    creditData: [],
                },
                order44U0: {
                    orderPrice: 0, // 订单总价
                    xianjye: 0,
                    taxCat: 0,
                    taxRate: 0,
                    orderPriceXj: 0, // 订单现金占用
                    orderPriceXjQk: 0, // 订单现金欠款
                    creditid: null, // 信贷id
                    orderPriceXd: 0, // 订单信贷占用
                    orderNetWorth: 0, // 订单净价值
                    creditData: [],
                },
                order1S00: {
                    orderPrice: 0, // 订单总价
                    xianjye: 0,
                    taxCat: 0,
                    taxRate: 0,
                    orderPriceXj: 0, // 订单现金占用
                    orderPriceXjQk: 0, // 订单现金欠款
                    creditid: null, // 信贷id
                    orderPriceXd: 0, // 订单信贷占用
                    orderNetWorth: 0, // 订单净价值
                    creditData: [],
                },

                order: {
                    id: null, // 主键
                    kucun:null,//库存地点
                    orderMainContract: null, // 主合同编号
                    orderSubContract: null, // 分合同编号
                    orderProjectCode: null, // 项目编号
                    orderProjectName: null, // 项目名称
                    orderCategory: null, // 订单类型
                    orderCategory1: null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
                    saleGroupCode: null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织
                    disChannelCode: null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
                    zCode: null, // 分销渠道编码-子编码
                    customerChannelCode: null, // 客户渠道
                    isStockUp: null, // 是否备货      1：是；0：否
                    orderStatus: null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
                    instid: null, // 流程id
                    taskId: null, // 流程id
                    tuihyy: null, // 退货原因
                    tuihyydes: null, // 退货原因说明
                    contactName: null, // 联系人名称
                    receivedTime: null, // 预计收货时间
                    soldToCode: null, // 售达方编码
                    soldToName: null, // 售达方名称
                    salesregion: null, // 送达方区域
                    salesregionName: null, // 送达方名称
                    soldToAreaCode: null, // 售达方地区编码
                    soldToAreaName: null, // 售达方地区名称
                    shipToCode: null, // 送达方编码
                    shipToName: null, // 送达方名称
                    shipToAreaCode: null, // 送达方地区编码
                    invoiceCode: null, // 开票方编码
                    payerCode: null, // 付款方编码
                    currencyCode: null, // 币种编码
                    orderPrice: 0, // 订单总价
                    orderPriceXj: 0, // 订单现金占用
                    orderPriceXjQk: 0, // 订单现金欠款
                    creditid: null, // 信贷id
                    orderPriceXd: 0, // 订单信贷占用
                    orderNetWorth: 0, // 订单净价值
                    poId: null, // PO号
                    areaId: null, // 区域详情表关联id
                    dcCode: null, // 配送中心编码
                    toProvincesCode: null, // 送达省份编码
                    toCityCode: null, // 送达城市编码
                    note: null, // 订单备注
                    postcode: null, // 邮政编码
                    firsttelephone: null, // 第一个电话
                    secondtelephone: null, // 第二电话
                    extraPrice: null, // 定制加价
                    customized: null, // 定制需求
                    sapsended: null, // 是否已提交sap,1-是,0-否
                    toAddress: null, // 收货地址
                    toCompanyname: null, // 送达方公司全称
                    posnr: null, // 外销:销售和分销凭证的项目号
                    inco1: null, // 外销:国际贸易条款 (部分1)
                    inco2: null, // 外销:国际贸易条款 (部分2)
                    submitflag: null,//提交标志
                    categoryName: null,
                    category1Name: null,
                    saleGrputName: null,
                    disChannelName: null,
                    zcodeName: null,
                    expoPrice: null,//展会价
                    fktj: null, //付款条件
                    costCenter9390: null,
                    costCenter9370: null,
                    costCenter9391: null,
                    costCenter1D90: null,
                    costCenter1RK0: null,
                    costCenter0PN0: null,
                    costCenter1R60: null,
                    costCenter44U0: null,
                    costCenter1S00: null,
                    businessReason: null,
                    isXietong: 0, // 是否协同收入
                },
                //产品list
                productlist1: [],
                productlist2: [],
                //客户渠道list
                customerChannelList: [],
                customerChannelListFilter: [],
                showXietong: false,

                //
            }
        },

        //页面加载前事件
        created() {
            console.log('我在这儿呀', this.$route.query.chongXinTiJiao);
            this.allxszz = this.$store.getters.dictlist('YLSalesOrganization_agent');
            this.customerChannelList = this.$store.getters.dictlist("sales_region");
            let id = this.$route.query.ywid;
            let instid = this.$route.query.instid;
            let taskid = this.$route.query.taskid;
            let taskstatus = this.$route.query.taskstatus | 0;
            let chongXinTiJiao = this.$route.query.chongXinTiJiao;
            //是否协同收入
            this.showXietong = this.$store.getters.hasRole("swyl_gndailishang,swyl_gwdailishang,swyl_xiaoshoujl,swyl_xiaoshoujl_wx,swyl_dingdgly,swyl_waixiaogly");
            //代办打开的
            if (id && instid) {
                this.resubmit = true;
                //如果不是重新提交,则不能添加跟删除了
                // if(!chongXinTiJiao){
                    this.showaddProductRow = false;
                    this.showdelProductRow = false;
                // }

                this.instid = instid;
                this.taskstatus = taskstatus;
                this.order.taskId = taskid;
                if (taskstatus == '1') {
                    // 直接设置经销商
                    this.selectDailishang = false;
                    const parent = document.querySelector(".input");
                    parent.className = "input el-input ";//改变父集的class,把父集改成可编辑状态，
                    //2.在设置input属性
                    //获取input
                    const input = document.querySelector(".input input");
                    //设置input的属性为false
                    input.disabled = false;
                }
            }
            this.getOrder(id || this.$route.query.id);
        },

        computed: {
            xsqyStr() {
                if (this.order.category1Name) {
                    return this.order.categoryName + "/" + this.order.category1Name
                }
                return this.order.categoryName
            },
            xszzStr() {
                return "["+this.order.saleGroupCode+"]"+this.order.saleGrputName
            },
        },
        watch: {
            productlist9390: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    //计算总金额
                    this.order9390.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                        return new big(sum).plus(v||0).toString();
                    }, 0)
                    //计算总净价值
                    this.order9390.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v || 0).toString();
                    }, 0)
                    //重新计算信贷
                    if (this.order9390.creditid) {
                        this.creditChange(this.order9390.creditid, '9390');
                    }
                },
            },
            productlist1D90: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    //计算总金额
                    this.order1D90.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                        return new big(sum).plus(v||0).toString();
                    }, 0)
                    //计算总净价值
                    this.order1D90.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v || 0).toString();
                    }, 0)
                    //重新计算信贷
                    if (this.order1D90.creditid) {
                        this.creditChange(this.order1D90.creditid, '1D90');
                    }
                },
            },

            productlist1RK0: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    //计算总金额
                    this.order1RK0.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                        return new big(sum).plus(v||0).toString();
                    }, 0)
                    //计算总净价值
                    this.order1RK0.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v || 0).toString();
                    }, 0)
                    //重新计算信贷
                    if (this.order1RK0.creditid) {
                        this.creditChange(this.order1RK0.creditid, '1RK0');
                    }
                },
            },

            productlist0PN0: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    //计算总金额
                    this.order0PN0.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                        return new big(sum).plus(v||0).toString();
                    }, 0)
                    //计算总净价值
                    this.order0PN0.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v || 0).toString();
                    }, 0)
                    //重新计算信贷
                    if (this.order0PN0.creditid) {
                        this.creditChange(this.order0PN0.creditid, '0PN0');
                    }
                },
            },
            productlist1R60: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    //计算总金额
                    this.order1R60.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                        return new big(sum).plus(v||0).toString();
                    }, 0)
                    //计算总净价值
                    this.order1R60.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v || 0).toString();
                    }, 0)
                    //重新计算信贷
                    if (this.order1R60.creditid) {
                        this.creditChange(this.order1R60.creditid, '1R60');
                    }
                },
            },
            productlist44U0: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    //计算总金额
                    this.order44U0.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                        return new big(sum).plus(v||0).toString();
                    }, 0)
                    //计算总净价值
                    this.order44U0.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v || 0).toString();
                    }, 0)
                    //重新计算信贷
                    if (this.order44U0.creditid) {
                        this.creditChange(this.order44U0.creditid, '44U0');
                    }
                },
            },
            productlist1S00: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    //计算总金额
                    this.order1S00.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                        return new big(sum).plus(v||0).toString();
                    }, 0)
                    //计算总净价值
                    this.order1S00.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v || 0).toString();
                    }, 0)
                    //重新计算信贷
                    if (this.order1S00.creditid) {
                        this.creditChange(this.order1S00.creditid, '1S00');
                    }
                },
            },

        },
        mounted() {

        },
        methods: {
            formatterZhifakufa(row, cellValue) {
                if (row.proType == 'OEM') {
                    //zhifakufa;//直发库发1：直发，2：库发
                    if (row.zhifakufa == 1) {
                        return '直发'
                    } else if (row.zhifakufa == 2) {
                        return '库发'
                    } else {
                        return ''
                    }
                } else {
                    return '自产'
                }
            },
            keyupEvent(e,input){
                e.target.value=e.target.value.replace(/[^\d.]/g, '');
                e.target.value=e.target.value.replace(/\.{2,}/g, '.');
                e.target.value=e.target.value.replace(/^\./g, '0.');
                e.target.value=e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0,e.target.value.length-1));
                e.target.value=e.target.value.replace(/^0[^\.]+/g, '0')
                e.target.value=e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
                this.input=e.target.value
            },
            //物流所需时间
            openReceivedTimefocus(){
              if(!this.openReceivedTimedisabled){
                  this.$msg.msge("请先选择的收货地址!");
              }
            },
            getOrder(id) {
                ss.OrderMainService.selectById(id).then(rd => {
                    _.assign(this.order, rd.obj)
                    this.ddlx = this.order.orderCategory + "," + (this.order.orderCategory1 || '');
                    let type = this.order.orderCategory1;
                    if(this.order.kucun == null || this.order.kucun == ''){
                        this.order.kucun = "0089";
                    }
                    //存在行项目
                    if (rd.obj.products && rd.obj.products.length > 0) {
                        //加载完现金跟信贷，在插入行项目
                        Promise.all([this.getCredit("9390")], this.getCredit("1D90"), this.getCredit("1RK0"), this.getCredit("0PN0"),this.getCredit("1R60"),this.getCredit("44U0"),this.getCredit("1S00")).then(() => {
                            rd.obj.products.forEach((obj) => {
                                if (obj) {
                                    this.addProject(obj);
                                }
                            })
                            Promise.all([this.getCredit("9390"), this.getCredit("1D90"), this.getCredit("1RK0"), this.getCredit("0PN0") ,this.getCredit("1R60") ,this.getCredit("44U0") ,this.getCredit("1S00")]).then(() => {
                                //重新计算信贷
                                if (this.order9390.creditid) {
                                    this.creditChange(this.order9390.creditid, '9390');
                                }
                                if (this.order1D90.creditid) {
                                    this.creditChange(this.order1D90.creditid, '1D90');
                                }
                                if (this.order1RK0.creditid) {
                                    this.creditChange(this.order1RK0.creditid, '1RK0');
                                }
                                if (this.order0PN0.creditid) {
                                    this.creditChange(this.order0PN0.creditid, '0PN0');
                                }
                                if (this.order1R60.creditid) {
                                    this.creditChange(this.order1R60.creditid, '1R60');
                                }
                                if (this.order44U0.creditid) {
                                    this.creditChange(this.order44U0.creditid, '44U0');
                                }
                                if (this.order1S00.creditid) {
                                    this.creditChange(this.order1S00.creditid, '1S00');
                                }
                            })
                        })
                    }
                    // 判断是否是经销商,经销商自己下单
                    //当前登录人，就是经销商的话
                    if (this._user.usertype == '1') {
                        this.order.soldToCode = this._user.usercode;
                        this.selectDailishang = false;
                    }
                    if (this.order.soldToCode) {
                        ss.selectUserAgent.getOneShoudf(this.order.soldToCode).then(rd => {
                            this.choseshoudf(rd, true);
                        })
                    }
                })
            },
            viewpress(r) {
                this.showhistory = true;
            },
            backtolist() {
                this.$router.go(-1);
            },
            saveOrSubmit(v) {

                this.order.orderStatus = v
                if (v == '10') {
                    this.order.submitflag = '暂存'
                } else if (v == '20') {
                    this.order.submitflag = '提交'
                }
              this.order.orderPrice = 0;
              this.order.orderPriceRbm = 0;

                _.forEach(this.productlist9390, (value) => {
                    value.xdid = this.order9390.creditid
                    value.totalpricermb = value.totalprice;
                    value.costCenter = this.order.costCenter9390;
                    this.order.orderPrice = new big(this.order.orderPrice||0).plus(value.totalprice||0);
                    this.order.orderPriceRbm = new big(this.order.orderPriceRbm||0).plus(value.totalprice||0);
                });
                _.forEach(this.productlist1D90, (value) => {
                    value.xdid = this.order1D90.creditid
                    value.totalpricermb = value.totalprice;
                    value.costCenter = this.order.costCenter1D90;
                    this.order.orderPrice = new big(this.order.orderPrice||0).plus(value.totalprice||0);
                    this.order.orderPriceRbm = new big(this.order.orderPriceRbm||0).plus(value.totalprice||0);
                });
                _.forEach(this.productlist1RK0, (value) => {
                    value.xdid = this.order1RK0.creditid
                    value.totalpricermb = value.totalprice;
                    value.costCenter = this.order.costCenter1RK0;
                    this.order.orderPrice = new big(this.order.orderPrice||0).plus(value.totalprice||0);
                    this.order.orderPriceRbm = new big(this.order.orderPriceRbm||0).plus(value.totalprice||0);
                });
                _.forEach(this.productlist0PN0, (value) => {
                    value.xdid = this.order0PN0.creditid
                    value.totalpricermb = value.totalprice;
                    value.costCenter = this.order.costCenter0PN0;
                    this.order.orderPrice = new big(this.order.orderPrice||0).plus(value.totalprice||0);
                    this.order.orderPriceRbm = new big(this.order.orderPriceRbm||0).plus(value.totalprice||0);
                });
                _.forEach(this.productlist44U0, (value) => {
                    value.xdid = this.order44U0.creditid
                    value.totalpricermb = value.totalprice;
                    value.costCenter = this.order.costCenter44U0;
                    this.order.orderPrice = new big(this.order.orderPrice||0).plus(value.totalprice||0);
                    this.order.orderPriceRbm = new big(this.order.orderPriceRbm||0).plus(value.totalprice||0);
                });
                _.forEach(this.productlist1S00, (value) => {
                    value.xdid = this.order1S00.creditid
                    value.totalpricermb = value.totalprice;
                    value.costCenter = this.order.costCenter1S00;
                    this.order.orderPrice = new big(this.order.orderPrice||0).plus(value.totalprice||0);
                    this.order.orderPriceRbm = new big(this.order.orderPriceRbm||0).plus(value.totalprice||0);
                });

                _.forEach(this.productlist1R60, (value) => {
                    value.xdid = this.order1R60.creditid
                    value.totalpricermb = value.totalprice;
                    value.costCenter = this.order.costCenter1R60;
                    this.order.orderPrice = new big(this.order.orderPrice||0).plus(value.totalprice||0);
                    this.order.orderPriceRbm = new big(this.order.orderPriceRbm||0).plus(value.totalprice||0);
                });
                this.order.orderPriceXj = new big(this.order9390.orderPriceXj||0).plus(this.order1D90.orderPriceXj||0).plus(this.order1RK0.orderPriceXj||0).plus(this.order0PN0.orderPriceXj||0).plus(this.order1R60.orderPriceXj||0).plus(this.order44U0.orderPriceXj||0).plus(this.order1S00.orderPriceXj||0).toString();
                this.order.orderPriceXd = new big(this.order9390.orderPriceXd||0).plus(this.order1D90.orderPriceXd||0).plus(this.order1RK0.orderPriceXd||0).plus(this.order0PN0.orderPriceXd||0).plus(this.order1R60.orderPriceXd||0).plus(this.order44U0.orderPriceXd||0).plus(this.order1S00.orderPriceXj||0).toString();
                this.order.orderNetWorth = this.order9390.orderNetWorth||'0'+this.order1D90.orderNetWorth||'0'+this.order1RK0.orderNetWorth||'0'+this.order0PN0.orderNetWorth||'0'+this.order1R60.orderNetWorth||'0'+this.order44U0.orderNetWorth||'0'+this.order1S00.orderNetWorth||'0';


                this.order.products = [...this.productlist9390, ...this.productlist1D90, ...this.productlist1RK0, ...this.productlist0PN0, ...this.productlist1R60, ...this.productlist44U0,...this.productlist1S00];

                for(var i=0;i<this.order.products.length;i++){
                    var obj = this.order.products[i];
                    if (obj.specialPrice == null || obj.specialPrice == '') {
                        if(obj.expoPrice < obj.proBenchmarkPrice){
                            this.$msg.msge("第"+(i+1)+"行，销售价不能小于基准价！");
                            return;
                        }
                    }
                }

                if (this.order.submitflag == '提交') {
                    this.$refs['form1'].validate((valid1) => {
                        if (valid1) {
                            this.$msg.confirm("确认提交？", () => {
                                this.submitForm();
                            })
                        } else {
                            this.$msg.msge("请完善基本信息后提交");
                            return;
                        }
                    });
                } else {
                    this.submitForm();
                }
            },
            submitForm() {
                if(this.submitChongfuFlag){
                    this.submitChongfuFlag = false;
                    ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
                        this.submitChongfuFlag = true;
                        if(rd.f){
                            if (this.order.submitflag == '提交') {
                                this.$msg.msgs("提交成功！")
                                this.$router.push({path:'/dingd/dingdwxlist'})
                            } else {
                                this.$msg.msgs("暂存成功！")
                            }
                        }else{
                            this.$msg.msge(rd.msg);
                        }
                    })
                }else{
                    this.$msg.msge("重复点击提交，请稍后操作！");
                }
            },
            resaveOrSubmit(v) {


                this.order.orderStatus = v
                this.$msg.confirm("确认提交？", () => {
                    this.order.submitflag = '重新提报'
                    ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
                        this.$router.push({path:'/dingd/dingdwxlist'})
                    })
                })
            },
            //查询用户，用户余额，所有信贷
            getCredit(gscode) {
                var params = {};
                //列表中的第一个的产品大类
                var cpdl = _.uniq(_.map(this['productlist' + gscode], "proModelCode"));
                if (cpdl.length == 1) {
                    params.cpdlcode = cpdl[0];
                }
                params.salegroupcode = gscode;
                params.usercode = this.order.soldToCode;
                // console.log(params)
                return ss.OrderMainService.getUserMoneyCredit(params).then(rd => {
                    console.log("信贷", rd)
                    this['order' + gscode].creditData = rd.xd;
                    this['order' + gscode].xianjye = rd.xj ? (rd.xj.cashBalance || 0) : 0;
                })
            }
            ,
            // 选择具体的信贷
            creditChange(v, gscode) {
                if (v) {
                    var orderje = this['order' + gscode].orderPrice;
                    var xd = _.find(this['order' + gscode].creditData, {id: v})
                    var xdye = xd.quota;
                    //用户的现金余额
                    var xjye = this['order' + gscode].xianjye;
                    if (xjye > 0) {
                        if (xjye >= orderje) {
                            this['order' + gscode].creditid = null;
                            this['order' + gscode].orderPriceXd = 0;
                        } else {
                            //现金+信贷>订单金额
                            if (xdye + xjye > orderje) {
                                this['order' + gscode].orderPriceXd = orderje - xjye;
                            } else {
                                if (orderje - xjye < xdye) {
                                    this['order' + gscode].orderPriceXd = orderje - xjye;
                                } else {
                                    this['order' + gscode].orderPriceXd = xdye;
                                }
                            }
                        }
                    } else {
//信贷金额，大于订单总额
                        if (xdye >= orderje) {
                            this['order' + gscode].orderPriceXd = orderje;
                        } else {
                            //订单减掉现金余额
                            this['order' + gscode].orderPriceXd = xdye;
                        }
                    }
                } else {
                    this['order' + gscode].creditid = null;
                    this['order' + gscode].orderPriceXd = 0;
                }
            },
            //特价改变
            changeTejia(scode, row) {
                console.log('特价改变', scode, row)
                if (row.specialOfferCode) {
                    const tjobj = _.find(row.tjlist, {tjdtid: row.specialOfferCode})
                    row.specialPrice = tjobj.tejia;
                    row.expoPrice = row.specialPrice;
                    row.specialPriceNum = tjobj.sysl;
                    row.expoPriceReadonly = true;
                } else {
                    row.specialOfferCode = null;
                    row.specialPrice = null;
                    row.expoPrice = null;
                    row.specialPriceNum = null;
                    row.expoPriceReadonly = false;
                }
            },
            //选择售达方
            openShoudf() {
                this.showshdfdialog = true;
            },
            choseshoudf(obj, changeflag) {
                //直单用户flag
                this.zhidanflag=obj.zhidanflag;
                //                设置客户渠道，
                this.customerChannelListFilter = _.filter(this.customerChannelList, (o) => {
                    return _.split("001,002,003,004,006,007,008" || '', ",").includes(o.code);
                });
                if (this.customerChannelListFilter.length > 0) {
                    this.order.customerChannelCode = this.order.customerChannelCode||this.customerChannelListFilter[0].code;
                } else {
                    if(this.order.orderCategory1 != '26'){
                        this.showshdfdialog = false
                        this.$msg.msge("该售达方没有维护客户渠道信息，请联系管理员！")
                        return;
                    }

                }
// 清空物料
                if (this.order.soldToCode != obj.usercode) {
                    this.productlist9390 = [];
                    this.productlist9370 = [];
                    this.productlist9391 = [];
                    this.productlist1D90 = [];
                    this.productlist1RK0 = [];
                    this.productlist0PN0 = [];
                    this.productlist1R60 = [];
                    this.productlist44U0 = [];
                    this.productlist1S00 = [];
                }
                this.order.soldToName = obj.username;
                this.order.soldToCode = obj.usercode;
                this.order.soldToAreaCode = obj.area;
                this.order.soldToAreaName = obj.areaname;
                //this.order.salesregion = changeflag?this.order.salesregion:obj.salesregion;
                this.order.salesregionName = changeflag?this.order.salesregionName:obj.salesregionName;
                this.order.gjmytk = obj.gjmytk; //国际贸易条款
                this.order.fktj = obj.fktj; //付款条件
                this.order.currencyCode = (changeflag ? this.order.currencyCode : obj.currency) || 'CNY';
                this.showshdfdialog = false

            },
            //
            deleteThis(row) {
                var id = row.id;
                var gscode = row.gscode;
                this.$msg.confirm("确认删除？", () => {
                    this['productlist' + gscode] = _.reject(this['productlist' + gscode], {'id': id});
                    this.getKuwei();
                })

            },


            //选择物料删除该行项目产品信息
            //选择物料
            showProcuct1() {
                if (!this.order.soldToCode) {
                    this.$msg.msge("请先选择售达方信息！")
                    return;
                }
                if(this.order.orderCategory1 == '26'){
                    this.showwuliaodialogWX = true;
                }else {
                    this.showwuliaodialog1 = true;
                }
            },
            //选择物料
            choseWuliao1(objs) {
                console.log("选中的物料", objs)
                this.showwuliaodialogWX = false;
                for (var i = 0; i < objs.length; i++) {

                    //校验是否有报关名称
                    if(!objs[i].customsName){
                        this.$message.error("报关名称为空，请先在海外报关主数据维护" + objs[i].matecode + "的中文名称！");
                        return ;
                    }

                    var wl = this.wlToProject(objs[i]);
                    console.log(wl);
                    //添加行项目
                    this.addProject(wl)
                }

                Promise.all([this.getCredit("9390"), this.getCredit("1D90"), this.getCredit("1RK0"), this.getCredit("0PN0"),this.getCredit("1R60"),this.getCredit("44U0"), this.getCredit("1S00")]).then(() => {
                    this['order9390'].creditid = this['order9390'].creditData.length > 0 ? _.first(this['order9390'].creditData).id : null;
                    this['order9390'].orderPriceXd = 0;
                    this['order1D90'].creditid = this['order1D90'].creditData.length > 0 ? _.first(this['order1D90'].creditData).id : null;
                    this['order1D90'].orderPriceXd = 0;
                    this['order1RK0'].creditid = this['order1RK0'].creditData.length > 0 ? _.first(this['order1RK0'].creditData).id : null;
                    this['order1RK0'].orderPriceXd = 0;
                    this['order0PN0'].creditid = this['order0PN0'].creditData.length > 0 ? _.first(this['order0PN0'].creditData).id : null;
                    this['order0PN0'].orderPriceXd = 0;
                    this['order1R60'].creditid = this['order1R60'].creditData.length > 0 ? _.first(this['order1R60'].creditData).id : null;
                    this['order1R60'].orderPriceXd = 0;
                    this['order44U0'].creditid = this['order44U0'].creditData.length > 0 ? _.first(this['order44U0'].creditData).id : null;
                    this['order44U0'].orderPriceXd = 0;
                    this['order1S00'].creditid = this['order1S00'].creditData.length > 0 ? _.first(this['order1S00'].creditData).id : null;
                    this['order1S00'].orderPriceXd = 0;

                })
                this.getKuwei();
            },
            //自动选择库位
            getKuwei(){
                if(this['productlist9390'].length>0){
                    if(this['productlist9390'][0].proType=='OEM'){

                        if(this['productlist9390'][0].factory=='1RK0' || this['productlist9390'][0].factory=='1R60'|| this['productlist9390'][0].factory=='0PN0'){
                            this.order.kucun = "0098";
                        }else if(this['productlist9390'][0].factory=='1S00' || this['productlist9390'][0].factory=='1S40') { //厚宏 OEM 0099
                            this.order.kucun = "0099";
                        }else {
                            this.order.kucun = "0099";
                        }
                    }else{
                        if(this['productlist9390'][0].factory=='9370'){
                            this.order.kucun = "7089";
                        }else if (this['productlist9390'][0].factory=='6200'){
                            this.order.kucun = "0099";
                        }else if (this['productlist9390'][0].factory=='1RK0' ){
                            this.order.kucun = "0098";
                        }else if (this['productlist9390'][0].factory=='0PN0' && this['productlist9390'][0].gscode=='6200'){
                            this.order.kucun = "9089";
                        }else if(this['productlist9390'][0].factory=='1S00' || this['productlist9390'][0].factory=='1S40') { //厚宏 自产 0088
                            this.order.kucun = "0088";
                        }else{
                            this.order.kucun = "0089";
                        }
                    }
                }
                if(this['productlist1D90'].length>0){
                    if(this['productlist1D90'][0].proType=='OEM'){

                        if(this['productlist1D90'][0].factory=='1RK0' || this['productlist1D90'][0].factory=='1R60' || this['productlist9390'][0].factory=='0PN0'){
                            this.order.kucun = "0098";
                        }else if(this['productlist1D90'][0].factory=='1S00' || this['productlist1D90'][0].factory=='1S40') { //厚宏 OEM 0099
                            this.order.kucun = "0099";
                        }else {
                            this.order.kucun = "0099";
                        }
                    }else{
                        if(this['productlist1D90'][0].factory=='9370'){
                            this.order.kucun = "7089";
                        }if(this['productlist1D90'][0].factory=='6200'){
                            this.order.kucun = "0099";
                        }else if (this['productlist1D90'][0].factory=='1RK0' ){
                            this.order.kucun = "0098";
                        }else if(this['productlist1D90'][0].factory=='0PN0' && this['productlist1D90'][0].gscode=='6200'){
                            this.order.kucun = "9089";
                        }else if(this['productlist1D90'][0].factory=='1S00' || this['productlist1D90'][0].factory=='1S40') { //厚宏 自产 0088
                            this.order.kucun = "0088";
                        }else{
                            this.order.kucun = "0089";
                        }
                    }
                }
                if(this['productlist1RK0'].length>0){
                    if(this['productlist1RK0'][0].proType=='OEM'){

                        if(this['productlist1RK0'][0].factory=='1RK0' || this['productlist1RK0'][0].factory=='1R60' || this['productlist1RK0'][0].factory=='0PN0'){
                            this.order.kucun = "0098";
                        }else if(this['productlist1RK0'][0].factory=='1S00' || this['productlist1RK0'][0].factory=='1S40') { //厚宏 OEM 0099
                            this.order.kucun = "0099";
                        }else {
                            this.order.kucun = "0099";
                        }
                    }else{
                        if(this['productlist1RK0'][0].factory=='9370'){
                            this.order.kucun = "7089";
                        }if(this['productlist1RK0'][0].factory=='6200'){
                            this.order.kucun = "0099";
                        }if(this['productlist1RK0'][0].factory=='1RK0' ){
                            this.order.kucun = "0098";
                        }else if(this['productlist1RK0'][0].factory=='0PN0' && this['productlist1RK0'][0].gscode=='6200'){
                            this.order.kucun = "9089";
                        }else if(this['productlist1RK0'][0].factory=='1S00' || this['productlist1RK0'][0].factory=='1S40') { //厚宏 自产 0088
                            this.order.kucun = "0088";
                        }else{
                            this.order.kucun = "0089";
                        }
                    }
                }
                if(this['productlist0PN0'].length>0){
                    if(this['productlist0PN0'][0].proType=='OEM'){

                        if(this['productlist0PN0'][0].factory=='1RK0' || this['productlist0PN0'][0].factory=='1R60' || this['productlist0PN0'][0].factory=='0PN0'){
                            this.order.kucun = "0098";
                        }else if(this['productlist0PN0'][0].factory=='1S00' || this['productlist0PN0'][0].factory=='1S40') { //厚宏 OEM 0099
                            this.order.kucun = "0099";
                        }else {
                            this.order.kucun = "0099";
                        }
                    }else{
                        if(this['productlist0PN0'][0].factory=='9370'){
                            this.order.kucun = "7089";
                        }if(this['productlist0PN0'][0].factory=='6200'){
                            this.order.kucun = "0099";
                        }if(this['productlist0PN0'][0].factory=='1RK0' ){
                            this.order.kucun = "0098";
                        }else if(this['productlist0PN0'][0].factory=='0PN0' && this['productlist0PN0'][0].gscode=='6200'){
                            this.order.kucun = "9089";
                        }else if(this['productlist0PN0'][0].factory=='1S00' || this['productlist0PN0'][0].factory=='1S40') { //厚宏 自产 0088
                            this.order.kucun = "0088";
                        }else{
                            this.order.kucun = "0089";
                        }
                    }
                }
                if(this['productlist1R60'].length>0){
                    if(this['productlist1R60'][0].proType=='OEM'){

                        if(this['productlist1R60'][0].factory=='1RK0' || this['productlist1R60'][0].factory=='1R60' || this['productlist1R60'][0].factory=='0PN0'){
                            this.order.kucun = "0098";
                        }else if(this['productlist1R60'][0].factory=='1S00' || this['productlist1R60'][0].factory=='1S40') { //厚宏 OEM 0099
                            this.order.kucun = "0099";
                        }else {
                            this.order.kucun = "0099";
                        }
                    }else{
                        if(this['productlist1R60'][0].factory=='9370'){
                            this.order.kucun = "7089";
                        }
                        if(this['productlist1R60'][0].factory=='6200'){
                            this.order.kucun = "0099";
                        }
                        if(this['productlist1R60'][0].factory=='1RK0' ){
                            this.order.kucun = "0098";
                        }

                        if(this['productlist1R60'][0].factory=='0PN0' && this['productlist1R60'][0].gscode=='6200'){
                            this.order.kucun = "9089";
                        }else if(this['productlist1R60'][0].factory=='1S00' || this['productlist1R60'][0].factory=='1S40') { //厚宏 自产 0088
                            this.order.kucun = "0088";
                        }else{
                            this.order.kucun = "0089";
                        }
                    }
                }
                if(this['productlist44U0'].length>0){
                    if(this['productlist44U0'][0].proType=='OEM'){

                        if(this['productlist44U0'][0].factory=='1RK0' || this['productlist44U0'][0].factory=='1R60' || this['productlist44U0'][0].factory=='0PN0'){
                            this.order.kucun = "0098";
                        }else if(this['productlist44U0'][0].factory=='44u0'){
                            this.order.kucun = "0099";
                        }else {
                            this.order.kucun = "0099";
                        }
                    }else{
                        if(this['productlist44U0'][0].factory=='9370'){
                            this.order.kucun = "7089";
                        }
                        if(this['productlist44U0'][0].factory=='6200'){
                            this.order.kucun = "0099";
                        }
                        if(this['productlist44U0'][0].factory=='1RK0' ){
                            this.order.kucun = "0098";
                        }else if(this['productlist44U0'][0].factory=='0PN0' && this['productlist44U0'][0].gscode=='6200') {
                            this.order.kucun = "9089";
                        }else if(this['productlist44U0'][0].factory=='44U0' ){
                            this.order.kucun = "0088";
                        }else{
                            this.order.kucun = "0089";
                        }
                    }
                }
                if(this['productlist1S00'].length>0){
                    if(this['productlist1S00'][0].proType=='OEM'){

                        if(this['productlist1S00'][0].factory=='1RK0' || this['productlist1S00'][0].factory=='1R60' || this['productlist1S00'][0].factory=='0PN0'){
                            this.order.kucun = "0098";
                        }else if(this['productlist1S00'][0].factory=='1S00' || this['productlist1S00'][0].factory=='1S40') { //厚宏 OEM 0099
                            this.order.kucun = "0099";
                        }else {
                            this.order.kucun = "0099";
                        }
                    }else{
                        if(this['productlist1S00'][0].factory=='9370'){
                            this.order.kucun = "7089";
                        }
                        if(this['productlist1S00'][0].factory=='6200'){
                            this.order.kucun = "0099";
                        }
                        if(this['productlist1S00'][0].factory=='1RK0' ){
                            this.order.kucun = "0098";
                        }else if(this['productlist1S00'][0].factory=='0PN0' && this['productlist1S00'][0].gscode=='6200') {
                            this.order.kucun = "9089";
                        }else if(this['productlist1S00'][0].factory=='1S00' || this['productlist1S00'][0].factory=='1S40') { //厚宏 自产 0088
                            this.order.kucun = "0088";
                        }else{
                            this.order.kucun = "0089";
                        }
                    }
                }
            },
            addProject(obj) {
                if(obj.tjlist && obj.tjlist.length>0 && !this.tejieshowflag){
                    this.tejieshowflag = true;
                }
                // 设置特价余量
                const checktejia = _.find(obj.tjlist,{tjdtid:obj.specialOfferCode})
                if(checktejia){
                    obj.specialPriceNum=checktejia.sysl
                    obj.expoPriceReadonly = true;
                }

                if(!this.order['costCenter' + obj.gscode]){
                    this.order['costCenter' + obj.gscode] = obj.costCenter||null;
                }
                obj.gscode = this.order.saleGroupCode;
                this['productlist' + obj.gscode].push(obj);
                this['order' + obj.gscode].creditid = obj.xdid;

            },
            wlToProject(obj) {
                var wl = {};
                wl.ycid = obj.yccode;//预测人
                wl.ycavailableNum = obj.availableNum;//预测剩余数量
                wl.ycrcode = obj.ycrcode;//预测人
                wl.ycrname = obj.ycrname;//预测人

                wl.id = this.$util.getUuid();
                wl.materialCode = obj.matecode;//物料编码
                wl.materialName = obj.matedes;//物料名称
                wl.proModelCode = obj.cpdlcode;//产品型号编码
                wl.proModelName = obj.cpdlname;//产品型号名称
                wl.cpz = obj.cpz; //产品组
                wl.dwcode = obj.dwcode;//单位
                wl.dwname = obj.dwname;//单位
                wl.currencyCode = obj.currency;//币种编码
                if(obj.taxCat != null && obj.taxCat != ''){
                    wl.taxCat = obj.taxCat;//税分类
                }else {
                    this.$msg.msge("税分类不能为空！");
                    return;
                }
                //税率
                if (wl.taxCat == '2' || wl.taxCat == '3' || wl.taxCat == '4') {
                    wl.taxRate = 1.13;
                } else if (wl.taxCat == '7') {
                    wl.taxRate = 1.06;
                } else {
                    wl.taxRate = 1;
                }

                wl.proNumber = 0;//产品数量
                wl.proBenchmarkPrice = obj.jizhj;//产品基准价
                wl.specialOfferCode = null; // 特价版本
                wl.specialPrice = null; // 特价价格
                wl.specialPriceNum = null; // 特价价格
                wl.isCustommed = 0; // 是否定制     1：是   0 否
                wl.extraPrice = null; // 定制加价
                wl.extraDes = null; // 定制需求
                wl.gscode = obj.companycode; //公司编码
                wl.proType = obj.protype; //自产还是oem
                wl.cgprice = obj.cgprice; //采购价
                wl.cgmll = obj.cgmll; //采购毛利率

                //售后单
                wl.finalPrice = 0;//成交价

                wl.totalprice = 0;//产品总价
                wl.tjlist = obj.tjlist;//特价list
                wl.expoPrice = obj.expoPrice || obj.jizhj;
                wl.fromtype = obj.fromtype;
                //产地
                wl.factory=obj.factory;
                wl.zhifakufa=obj.delivery_method;
                wl.measure=obj.MEASURE;
                wl.oemDesc = obj.oemDesc;//OEM产品描述
                //报关名称
                wl.customsName=obj.customsName;
                return wl;
            },
            //选择地址
            selectAreadialog() {
                this.showdizhiflag = true;
            },
            choseDizhi(obj) {

                console.log("选中的地址", obj)
                this.order.addressCode = obj.id;
                this.order.areaId = obj.id;
                this.order.toAddress = obj.quobj.namepath;
                if (obj.zhenobj) {
                    // this.order.toAddress = obj.zhenobj.namepath;
                    obj.addrdetail = obj.zhenobj.name+"/"+obj.addrdetail;
                }
                this.order.toAddress = this.order.toAddress + "##"+obj.addrdetail

                this.order.toProvincesCode = obj.shengobj.code;
                this.order.toProvincesName = obj.shengobj.name;

                this.order.toCityCode = obj.shiobj.code;2
                this.order.toCityName = obj.shiobj.name;

                this.showdizhiflag = false;


                //清空时间
                this.order.receivedTime = null;
                this.openReceivedTimedisabled = false;
                //根据地址，获取预计收货时间
                // ss.OrderMainService.getSendDays(obj.qu).then(rd => {
                //     this.startDateLimit = _.assign({}, this.startDateLimit, {
                //         disabledDate: (time) => {
                //             return time.getTime() < new big(rd).plus(2).times(24 * 60 * 60 * 1000).plus(Date.now()).toString()
                //         }
                //     })
                // })
            },
        }
    }
</script>
<style scoped>
    .queren {
        background-color: #006aca;
        color: white;
    }

    .anniu {
        margin-left: 6rem;
        margin-top: 30px;
    }

    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .quxiao, .zancun {
        width: 100px;
    }

    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
    }

    .jieguo .jieguo_label {
        width: 2rem;
        text-align: right;
        background-color: #ebf5ff;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0 0.05rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .jieguo .jieguo_value {
        width: 19%;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0px 8px;
    }

    img {
        width: 25px;
        padding: 5px 0;
    }

    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }
</style>
<style>
    .n-two .h-formbLine .el-form-item__content .el-select,
    .n-two .el-form .h-formbLine .el-form-item__content .el-select {
        width: 0;
    }

    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
        z-index: 999999;
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;

        }

        .createNxs {
            position: absolute;
            z-index: 1;

        }

        .createNx1 {
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }


        .createNxbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.4rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
            z-index: 2;
        }
    }
</style>
